/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  useEffect(() => {
    const showButton = () => {
      setClick(false); // Close the mobile menu on resize
    };

    window.addEventListener('resize', showButton);

    return () => {
      window.removeEventListener('resize', showButton);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <img className="logo" src={process.env.PUBLIC_URL + '/assets/logo-mastered-trax-logo.png'} alt="MasteredTrax Logo" />
        </Link>
        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>
        <ul className={click ? 'nav-menu nav-menu--visible' : 'nav-menu nav-menu--hidden'}>
          <li className='nav-item'>
            <Link to='/' className='nav-link' onClick={closeMobileMenu}>
              INICIO
            </Link>
          </li>
          <li className='nav-item'>
            <Link to='/Artists' className='nav-link' onClick={closeMobileMenu}>
              ARTISTAS
            </Link>
          </li>
          <li className='nav-item'>
            <Link to='/Videos' className='nav-link' onClick={closeMobileMenu}>
              VIDEOS
            </Link>
          </li>
          <li className='nav-item'>
          <a href='https://masteredtrax.shop' className='nav-link'>
            TIENDA
          </a>
          </li>
          <li className='nav-item'>
            <Link to='/About' className='nav-link' onClick={closeMobileMenu}>
              ABOUT
            </Link>
          </li>
          <li className='nav-item'>
            <Link to='/Contact' className='nav-link' onClick={closeMobileMenu}>
              CONTACTO
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
